import { Location } from '@angular/common';
import { IntervinientesService } from './../../services/intervinientes.service';
import { ExpedientesService } from './../../services/expedientes.service';
import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-expediente-interviniente',
  templateUrl: './expediente-interviniente.component.html',
  styleUrls: ['./expediente-interviniente.component.css']
})
export class ExpedienteIntervinienteComponent implements OnInit {

  @ViewChild("mensaje") mensaje:ElementRef;
  codigo;
  interviniente={};
  intervinientes=[];

  constructor(private location:Location, private activatedRoute:ActivatedRoute, private intervinientesService:IntervinientesService,
    private expedientesService:ExpedientesService, private router:Router, private renderer:Renderer2) { 
      
    if(!this.expedientesService.expedienteActivo){
      this.location.back();
    }

    this.activatedRoute.params.subscribe(params=>{
      this.codigo=params["cod"];
    });
  }

  ngOnInit() {
    this.cargarIntervinientes();

    if(this.codigo!="nuevo"){
      this.cargarInterviniente();
    }else{
      this.interviniente={};
    }

  }

  cargarInterviniente(){
    this.expedientesService.getInterviniente(this.codigo)
    .subscribe(resp=>{
      this.interviniente=resp["interviniente"];
      this.interviniente["EIfechainicio"]=this.interviniente["EIfechainicio"].substring(0,10);
      return true;
    });
  }

  cargarIntervinientes(){
    this.intervinientesService.getNombresIntervinientes().subscribe();
  }

  updateInterviniente(){
    this.expedientesService.updateInterviniente(this.codigo, this.interviniente)
    .subscribe(resp=>{
      let texto=this.renderer.createText(resp["mensaje"]);
      this.renderer.appendChild(this.mensaje.nativeElement, texto);
      if(resp["err"]==false){
        this.renderer.setStyle(this.mensaje.nativeElement,"color", "green");
      }else{
        this.renderer.setStyle(this.mensaje.nativeElement,"color", "red");
      }
      setTimeout(() => {
        this.renderer.removeChild(this.mensaje.nativeElement, texto);
        this.location.back();
      }, 2000);
    });
  }

  insertInterviniente(){
    this.expedientesService.insertInterviniente(this.interviniente )
    .subscribe(resp=>{
      let texto=this.renderer.createText(resp["mensaje"]);
      this.renderer.appendChild(this.mensaje.nativeElement, texto);
      if(resp["err"]==false){
        this.renderer.setStyle(this.mensaje.nativeElement,"color", "green");
      }else{
        this.renderer.setStyle(this.mensaje.nativeElement,"color", "red");
      }
      setTimeout(() => {
        this.renderer.removeChild(this.mensaje.nativeElement, texto);
        this.location.back();
      }, 2000);
    });
  }

  guardarInterviniente(){
    if(this.codigo=="nuevo"){
      this.insertInterviniente();
    }else{
      this.updateInterviniente();
    }
  }

  parseDate(dateString: string){
    if (dateString) {
      let fecha=new Date(dateString);
      var myDate_string = fecha.toISOString();
      var myDate_string = myDate_string.replace("T"," ");
      var myDate_string = myDate_string.substring(0,10);
        return myDate_string;
    } else {
        return null;
    }
}

volver(){
  this.location.back();
}

}



// WEBPACK FOOTER //
// ./src/app/components/expediente-interviniente/expediente-interviniente.component.ts